import type { SVGProps } from 'react';

export const Lock = (props: SVGProps<SVGSVGElement>) => (
    <svg width='24' height='24' fill='currentColor' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='M8 10V8a4 4 0 0 1 8 0h2A6 6 0 1 0 6 8v2H4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10H8ZM6 20v-8h12v8H6Z' />
        <path d='M9 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM15 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z' />
    </svg>
);
